"use client";

import { ACTIVITY_LEVELS } from "@/types";

interface Props {
  level?: number | null;
  label?: string | null;
  emoji?: string | null;
  size?: "sm" | "md";
}

/** 운영자 글 작성자 배지 (#11) — 닉네임 옆 황금색 chip. */
export function AdminAuthorBadge({ size = "sm" }: { size?: "sm" | "md" }) {
  const cls =
    size === "md"
      ? "text-xs px-2 py-0.5 rounded-md font-bold border"
      : "text-2xs px-1.5 py-0.5 rounded-md font-bold border";
  return (
    <span
      className={cls}
      style={{
        backgroundColor: "#FFD93D1F",
        color: "#FFD93D",
        borderColor: "#FFD93D40",
      }}
      title="트렌드레인 운영자"
    >
      👑 운영자
    </span>
  );
}

/**
 * 유저 활동 등급 배지 (마이그 035, #2).
 * 닉네임 옆 작은 chip — 색깔 활동 단계 별 매칭.
 */
export function UserLevelBadge({ level, label, emoji, size = "sm" }: Props) {
  if (!level) return null;
  const meta = ACTIVITY_LEVELS.find((l) => l.level === level) ?? ACTIVITY_LEVELS[0];
  const finalLabel = label ?? meta.label;
  const finalEmoji = emoji ?? meta.emoji;
  const cls =
    size === "md"
      ? "text-xs px-2 py-0.5 rounded-md font-bold border"
      : "text-2xs px-1.5 py-0.5 rounded-md font-bold border";
  return (
    <span
      className={cls}
      style={{
        backgroundColor: `${meta.color}1F`,
        color: meta.color,
        borderColor: `${meta.color}40`,
      }}
      title={`Lv.${level} ${finalLabel}`}
    >
      <span aria-hidden>{finalEmoji}</span> Lv.{level}
    </span>
  );
}
